'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Aller à',
  jump_to_confirm: 'confirmer',
  page: '',

  // Pagination.jsx
  prev_page: 'Page précédente',
  next_page: 'Page suivante',
  prev_5: '5 Pages précédentes',
  next_5: '5 Pages suivantes',
  prev_3: '3 Pages précédentes',
  next_3: '3 Pages suivantes'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-pagination/lib/locale/fr_FR.js
// module id = 2561
// module chunks = 0